import { render, staticRenderFns } from "./RegisterDataKeuangan.vue?vue&type=template&id=06b6690a&scoped=true&"
import script from "./RegisterDataKeuangan.vue?vue&type=script&lang=js&"
export * from "./RegisterDataKeuangan.vue?vue&type=script&lang=js&"
import style0 from "./RegisterDataKeuangan.vue?vue&type=style&index=0&id=06b6690a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06b6690a",
  null
  
)

export default component.exports